(() => {
  // work/global-launch-options-2026-11-03/adapter/src/charge-price-adapter.mjs
  var suffix = (id) => String(id).split("/").pop();
  var check = (ok, message) => {
    if (!ok) throw Error(message);
  };
  function adaptChargeCatalogue(catalog, binding, pairs) {
    check(["wheels", "airride"].includes(binding?.family), "Unsupported charge family");
    check(binding.policies?.length === 1 && binding.policies[0].policy?.v === 2, "One exact native parent policy required");
    const allowed = new Set(binding.policies[0].policy.d.map(suffix)), routes = /* @__PURE__ */ new Map();
    for (const pair of pairs.filter((p) => p.family === binding.family)) {
      const old = suffix(pair.oldVariantId), next = suffix(pair.newVariantId);
      check(!(allowed.has(old) && allowed.has(next)), "Ambiguous charge generation");
      if (!allowed.has(old) && !allowed.has(next)) continue;
      const target = allowed.has(next) ? next : old;
      for (const id of [old, next]) {
        check(!routes.has(id) || routes.get(id) === target, "Conflicting charge mapping");
        routes.set(id, target);
      }
    }
    const out = structuredClone(catalog), seen = /* @__PURE__ */ new Set();
    const visit = (value) => {
      if (Array.isArray(value)) {
        value.forEach(visit);
        return;
      }
      if (!value || typeof value !== "object") return;
      for (const [key, item] of Object.entries(value)) {
        if (key === "chargeVariantId" && item != null && item !== "") {
          const id = suffix(item), target = routes.get(id);
          check(target && allowed.has(target), "Catalogue charge has no active policy route: " + id);
          value[key] = String(item).startsWith("gid://") ? "gid://shopify/ProductVariant/" + target : target;
          seen.add(target);
        } else visit(item);
      }
    };
    visit(out);
    check(seen.size > 0, "No catalogue charge references were verified");
    return out;
  }

  // work/global-launch-options-2026-11-03/adapter/src/charge-id-routes.json
  var charge_id_routes_default = [
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/68055792582884",
      newVariantId: "gid://shopify/ProductVariant/68077949649124"
    },
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/37470293721247",
      newVariantId: "gid://shopify/ProductVariant/68077949681892"
    },
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/37470648008863",
      newVariantId: "gid://shopify/ProductVariant/68077949714660"
    },
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/37470254039199",
      newVariantId: "gid://shopify/ProductVariant/68077949747428"
    },
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/37470492885151",
      newVariantId: "gid://shopify/ProductVariant/68077949780196"
    },
    {
      family: "airride",
      oldVariantId: "gid://shopify/ProductVariant/46034532401380",
      newVariantId: "gid://shopify/ProductVariant/68077949812964"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339686338788",
      newVariantId: "gid://shopify/ProductVariant/68077954990308"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339721695460",
      newVariantId: "gid://shopify/ProductVariant/68077955023076"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/47065374130404",
      newVariantId: "gid://shopify/ProductVariant/68077955055844"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/47065378586852",
      newVariantId: "gid://shopify/ProductVariant/68077955088612"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/47065374064868",
      newVariantId: "gid://shopify/ProductVariant/68077955121380"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/47065378521316",
      newVariantId: "gid://shopify/ProductVariant/68077955154148"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491817513188",
      newVariantId: "gid://shopify/ProductVariant/68077955186916"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/47065370427620",
      newVariantId: "gid://shopify/ProductVariant/68077955219684"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491818037476",
      newVariantId: "gid://shopify/ProductVariant/68077955252452"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491818070244",
      newVariantId: "gid://shopify/ProductVariant/68077955285220"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491818103012",
      newVariantId: "gid://shopify/ProductVariant/68077955317988"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339681226980",
      newVariantId: "gid://shopify/ProductVariant/68077955350756"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491818496228",
      newVariantId: "gid://shopify/ProductVariant/68077955383524"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995340714212",
      newVariantId: "gid://shopify/ProductVariant/68077955416292"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491818594532",
      newVariantId: "gid://shopify/ProductVariant/68077955449060"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341074660",
      newVariantId: "gid://shopify/ProductVariant/68077955481828"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491820495076",
      newVariantId: "gid://shopify/ProductVariant/68077955514596"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339632402660",
      newVariantId: "gid://shopify/ProductVariant/68077955547364"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491820560612",
      newVariantId: "gid://shopify/ProductVariant/68077955580132"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491820593380",
      newVariantId: "gid://shopify/ProductVariant/68077955612900"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491821084900",
      newVariantId: "gid://shopify/ProductVariant/68077955645668"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341107428",
      newVariantId: "gid://shopify/ProductVariant/68077955678436"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491822919908",
      newVariantId: "gid://shopify/ProductVariant/68077955711204"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341140196",
      newVariantId: "gid://shopify/ProductVariant/68077955743972"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491823247588",
      newVariantId: "gid://shopify/ProductVariant/68077955776740"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341172964",
      newVariantId: "gid://shopify/ProductVariant/68077955809508"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339593048292",
      newVariantId: "gid://shopify/ProductVariant/68077955842276"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491824328932",
      newVariantId: "gid://shopify/ProductVariant/68077955875044"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45565232546020",
      newVariantId: "gid://shopify/ProductVariant/68077955907812"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341205732",
      newVariantId: "gid://shopify/ProductVariant/68077955940580"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339518632164",
      newVariantId: "gid://shopify/ProductVariant/68077955973348"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491824361700",
      newVariantId: "gid://shopify/ProductVariant/68077956006116"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339518861540",
      newVariantId: "gid://shopify/ProductVariant/68077956038884"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491824951524",
      newVariantId: "gid://shopify/ProductVariant/68077956071652"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339518894308",
      newVariantId: "gid://shopify/ProductVariant/68077956104420"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45491833667812",
      newVariantId: "gid://shopify/ProductVariant/68077956137188"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519123684",
      newVariantId: "gid://shopify/ProductVariant/68077956169956"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519156452",
      newVariantId: "gid://shopify/ProductVariant/68077956202724"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341238500",
      newVariantId: "gid://shopify/ProductVariant/68077956235492"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519385828",
      newVariantId: "gid://shopify/ProductVariant/68077956268260"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519418596",
      newVariantId: "gid://shopify/ProductVariant/68077956301028"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341893860",
      newVariantId: "gid://shopify/ProductVariant/68077956333796"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519451364",
      newVariantId: "gid://shopify/ProductVariant/68077956366564"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339559493860",
      newVariantId: "gid://shopify/ProductVariant/68077956399332"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519484132",
      newVariantId: "gid://shopify/ProductVariant/68077956432100"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339559526628",
      newVariantId: "gid://shopify/ProductVariant/68077956464868"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339559788772",
      newVariantId: "gid://shopify/ProductVariant/68077956497636"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/48995341926628",
      newVariantId: "gid://shopify/ProductVariant/68077956530404"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339559821540",
      newVariantId: "gid://shopify/ProductVariant/68077956563172"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519680740",
      newVariantId: "gid://shopify/ProductVariant/68077956595940"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339559854308",
      newVariantId: "gid://shopify/ProductVariant/68077956628708"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560050916",
      newVariantId: "gid://shopify/ProductVariant/68077956661476"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339519713508",
      newVariantId: "gid://shopify/ProductVariant/68077956694244"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560083684",
      newVariantId: "gid://shopify/ProductVariant/68077956727012"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560116452",
      newVariantId: "gid://shopify/ProductVariant/68077956759780"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560345828",
      newVariantId: "gid://shopify/ProductVariant/68077956792548"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560542436",
      newVariantId: "gid://shopify/ProductVariant/68077956825316"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560575204",
      newVariantId: "gid://shopify/ProductVariant/68077956858084"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560607972",
      newVariantId: "gid://shopify/ProductVariant/68077956890852"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560640740",
      newVariantId: "gid://shopify/ProductVariant/68077956923620"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560837348",
      newVariantId: "gid://shopify/ProductVariant/68077956956388"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339560870116",
      newVariantId: "gid://shopify/ProductVariant/68077956989156"
    },
    {
      family: "wheels",
      oldVariantId: "gid://shopify/ProductVariant/45339561099492",
      newVariantId: "gid://shopify/ProductVariant/68077957021924"
    }
  ];

  // work/global-launch-options-2026-11-03/adapter/src/catalogue-routing.mjs
  var suffix2 = (id) => String(id).split("/").pop();
  function prepareChargeCatalogue(catalog, binding, family, { allowGroupedTest = false } = {}) {
    const pairs = charge_id_routes_default.filter((pair) => pair.family === family);
    const grouped = new Set(pairs.map((pair) => suffix2(pair.newVariantId)));
    if (binding) {
      if (binding.family !== family || String(binding.productId) !== String(catalog.productId)) throw Error("Charge policy does not match this product");
      if (!allowGroupedTest && binding.policies?.some((row) => row.policy?.d?.some((id) => grouped.has(suffix2(id))))) throw Error("Grouped option routing awaits Merchant feed exclusion verification");
      if (family === "airride") {
        const out = structuredClone(catalog);
        const paid = out.options.flatMap((option) => option.values).filter((value) => value.price > 0);
        const adapted = adaptChargeCatalogue({ options: paid }, binding, charge_id_routes_default);
        paid.forEach((value, index) => {
          value.chargeVariantId = adapted.options[index].chargeVariantId;
        });
        return out;
      }
      return adaptChargeCatalogue(catalog, binding, charge_id_routes_default);
    }
    const old = new Set(pairs.map((pair) => suffix2(pair.oldVariantId)));
    const visit = (value) => {
      if (!value || typeof value !== "object") return;
      for (const [key, item] of Object.entries(value)) {
        if (key === "chargeVariantId" && item != null && item !== "") {
          if (!old.has(suffix2(item))) throw Error("Charge reference requires an exact native policy");
        } else visit(item);
      }
    };
    visit(family === "airride" ? catalog.options.flatMap((option) => option.values).filter((value) => value.price > 0) : catalog);
    return structuredClone(catalog);
  }

  // work/global-launch-options-2026-11-03/adapter/src/wheels-entry.mjs
  (() => {
    const section = document.querySelector("[data-ceika-wheels-preview]");
    const root = section?.querySelector("ceika-native-configurator");
    if (!root) return;
    const button = section.querySelector("[data-wheel-cart-add]"), status = section.querySelector("[data-wheel-cart-status]");
    button.disabled = true;
    button.addEventListener("click", () => {
      if (button.dataset.r2PurchaseReady === "true") return;
      button.disabled = true;
      status.textContent = "Preview only \xB7 purchasing is disabled.";
    });
    const route = window.Shopify?.routes?.root || "/";
    async function request(path, body) {
      if (body) throw Error("Purchasing is disabled in this preview.");
      if (!/^\/(?:[a-z0-9-]+\/)*$/i.test(route) || !/^(?:cart\.js|variants\/\d+\.js)$/.test(path)) throw Error("Invalid preview price request");
      const response = await fetch(route + path, { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" }, signal: AbortSignal.timeout(2e4) });
      if (!response.ok) throw Error("Option prices could not be verified. Refresh the preview.");
      return response.json();
    }
    async function init() {
      const source = window.CeikaWheelFamilyCatalog;
      if (!source || String(section.dataset.productId) !== source.productId) throw Error("This wheel product is not connected to the preview.");
      const binding = JSON.parse(section.querySelector("[data-wheel-commerce-binding]")?.textContent || "null");
      const catalog = prepareChargeCatalogue(source, binding, "wheels");
      const controls = JSON.parse(section.querySelector("[data-wheel-option-controls]")?.textContent || "null");
      if (controls) {
        if (controls.schemaVersion !== 1 || controls.family !== "wheels" || String(controls.productId) !== catalog.productId || controls.sourceProfileHash !== catalog.sourceProfileHash || !Array.isArray(controls.disabledOptionKeys)) throw Error("Wheel option settings need review.");
        for (const key of controls.disabledOptionKeys) {
          const rule = Object.values(catalog.managerControls).find((r) => r.key === key), option = catalog.options.find((o) => o.key === key), value = option?.values.find((v) => v.key === rule?.fallback);
          if (!value || value.price !== 0 || value.chargeVariantId) throw Error("Wheel option settings need review.");
          option.values = [value];
          const group = root.querySelector(`[data-group="${key}"]`);
          group?.querySelector('[data-value="Not added"]')?.click();
          if (group) {
            group.hidden = true;
            group.querySelectorAll("button").forEach((b) => b.disabled = true);
          }
        }
      }
      const before = await request("cart.js"), country = window.Shopify.country;
      const ids = [.../* @__PURE__ */ new Set([catalog.priceVariantId, ...catalog.options.flatMap((o) => o.values.map((v) => v.chargeVariantId).filter(Boolean))])];
      const prices = {}, queue = [...ids];
      await Promise.all(Array.from({ length: 6 }, async () => {
        while (queue.length) {
          const id = queue.shift(), v = await request("variants/" + id + ".js");
          if (String(v.id) !== id || !Number.isSafeInteger(v.price) || v.price < 0) throw Error("Option prices could not be verified.");
          prices[id] = { price: v.price, currency: before.currency, available: v.available === true };
        }
      }));
      if ((await request("cart.js")).currency !== before.currency || window.Shopify.country !== country) throw Error("Your market changed. Refresh the preview.");
      window.CeikaWheelMarket = { currency: before.currency, prices, catalog };
      root.dataset.priceVerification = "verified";
      status.textContent = "Market prices verified \xB7 preview only \xB7 purchasing disabled.";
      root.dispatchEvent(new Event("ceika:request-total"));
    }
    init().catch((error) => {
      button.disabled = true;
      root.dataset.priceVerification = "failed";
      status.textContent = error.message;
    });
  })();
})();
